import React, { useState } from 'react';
import { View, ScrollView } from 'react-native';
import { Card } from 'react-native-paper';
import { SafeAreaView } from 'react-native-safe-area-context';
import { CheckBox } from 'react-native-elements/dist/checkbox/CheckBox';
import { useDispatch, useSelector } from 'react-redux';

import styles from './styles';
import { AppHeader } from '../../../components/common';
import { appColors } from '../../../assets/styles/global';
import { AppText, AppButton } from '../../../components/form';
import { UserActions } from '../../../redux/reducers/userReducer';

export default function selectDateLive({ navigation }) {
  const dispatch = useDispatch();
  const [daysSelect, setDaysSelect] = useState([]);
  const { userSignUp } = useSelector((state) => state.user);
  // useEffect(() => {
  //   dispatch({
  //     type: UserActions.UPDATE_SIGNUP,
  //     userSignUp: {
  //       ...userSignUp, segunda: 0, terca: 0, quarta: 0, quinta: 0, sexta: 0, sabado: 0, domingo: 0, horario: '',
  //     },
  //   });
  // }, []);

  // eslint-disable-next-line consistent-return
  const handlePressDay = (day) => {
    const dayIsSelect = daysSelect.findIndex((daySelect) => daySelect === day);

    const unSetDay = (index) => {
      const temp = [...daysSelect];
      temp.splice(index, 1);
      setDaysSelect(temp);
    };

    if (daysSelect.length === 2) {
      if (dayIsSelect >= 0) {
        unSetDay(dayIsSelect);
      } else return null;
    } else {
      if (daysSelect[dayIsSelect] === day) {
        return unSetDay(day);
      }
      return setDaysSelect([...daysSelect, day]);
    }
  };

  const verifyCheck = (day) => {
    const findDay = daysSelect.findIndex((fDay) => fDay === day);
    if (findDay < 0) {
      return false;
    }
    return true;
  };

  const handleNextPage = () => {
    // eslint-disable-next-line array-callback-return

    dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, [daysSelect[0]]: 1, [daysSelect[1]]: 1 } });

    navigation.navigate('Selecione o Personal');
  };

  const getHours = () => {
    const hours = [];
    for (let i = 0; i <= 23; i++) {
      hours.push(`${i < 10 ? `0${i}` : i}:00`);
    }
    return (
      hours.map((hour, index) => (
        <AppButton
          key={`hour-${index}`}
          label={hour}
          style={[styles.buttonBadge, userSignUp.horario === hour && styles.buttonBadgeSelected]}
          labelStyle={styles.textBadge}
          onPress={() => dispatch({ type: UserActions.UPDATE_SIGNUP, userSignUp: { ...userSignUp, horario: userSignUp.horario === hour ? '' : hour } })}
        />
      ))
    );
  };
  return (
    <>
      <AppHeader navigation={navigation} hasBack title="Selecione as Datas" />
      <SafeAreaView style={styles.viewBase}>
        <ScrollView style={styles.scroll}>
          <Card style={styles.cardCalendar}>
            <AppText style={styles.TitleCalendar}>Selecione dois dias da Semana</AppText>
            <View style={{ flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' }}>
              <CheckBox title={<AppText style={styles.textCheck}>Segunda</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={verifyCheck('segunda')} onPress={() => handlePressDay('segunda')} />
              <CheckBox title={<AppText style={styles.textCheck}>Terça</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={verifyCheck('terca')} onPress={() => handlePressDay('terca')} />
              <CheckBox title={<AppText style={styles.textCheck}>Quarta</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={verifyCheck('quarta')} onPress={() => handlePressDay('quarta')} />
              <CheckBox title={<AppText style={styles.textCheck}>Quinta</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={verifyCheck('quinta')} onPress={() => handlePressDay('quinta')} />
              <CheckBox title={<AppText style={styles.textCheck}>Sexta</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={verifyCheck('sexta')} onPress={() => handlePressDay('sexta')} />
              <CheckBox title={<AppText style={styles.textCheck}>Sábado</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={verifyCheck('sabado')} onPress={() => handlePressDay('sabado')} />
              <CheckBox title={<AppText style={styles.textCheck}>Domingo</AppText>} containerStyle={styles.check} checkedColor={appColors.primary} checked={verifyCheck('domingo')} onPress={() => handlePressDay('domingo')} />
            </View>
          </Card>
          <Card style={styles.card}>
            <View style={styles.cardContent}>
              <AppText style={styles.TitleCalendar}>Horários:</AppText>
              <View style={styles.groupButtonsHours}>{ getHours() }</View>
            </View>
            <AppButton disabled={daysSelect.length !== 2 || userSignUp.horario === ''} label="AVANÇAR" style={styles.nextButton} labelStyle={styles.textBadge} onPress={() => handleNextPage()} />
          </Card>
        </ScrollView>

      </SafeAreaView>
    </>
  );
}
